import { DeliveryMethod } from '../types';

interface MethodOption {
  id: DeliveryMethod;
  label: string;
  icon: string;
  description: string;
}

const METHODS: MethodOption[] = [
  {
    id: 'zip',
    label: 'Download ZIP Package',
    icon: 'ri-folder-zip-line',
    description: 'All files bundled in a single ZIP archive, ready to upload.',
  },
  {
    id: 'clipboard',
    label: 'Copy Text to Clipboard',
    icon: 'ri-clipboard-line',
    description: 'Copies your ad copy, headlines, and CTAs straight to your clipboard.',
  },
  {
    id: 'individual',
    label: 'Export Assets Individually',
    icon: 'ri-download-2-line',
    description: 'Download each file one at a time. Best for selective exports.',
  },
];

interface DeliveryMethodProps {
  value: DeliveryMethod;
  onChange: (v: DeliveryMethod) => void;
}

export default function DeliveryMethodSection({ value, onChange }: DeliveryMethodProps) {
  return (
    <div className="bg-stone-900 border border-stone-800 rounded-xl p-5 mb-4">
      <h3 className="text-sm font-semibold text-white mb-4">Delivery Method</h3>
      <div className="flex flex-col gap-2">
        {METHODS.map((m) => {
          const isActive = value === m.id;
          return (
            <button
              key={m.id}
              onClick={() => onChange(m.id)}
              className={`flex items-center gap-4 px-4 py-3.5 rounded-xl border text-left transition-all duration-200 cursor-pointer ${
                isActive
                  ? 'bg-orange-500/10 border-orange-500/60 ring-1 ring-orange-500/30'
                  : 'bg-stone-800/40 border-stone-700/60 hover:border-stone-600'
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-xl shrink-0 ${isActive ? 'bg-orange-500/20' : 'bg-stone-800'}`}>
                <i className={`${m.icon} text-base ${isActive ? 'text-orange-400' : 'text-stone-400'}`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-semibold mb-0.5 ${isActive ? 'text-white' : 'text-stone-300'}`}>{m.label}</div>
                <p className="text-xs text-stone-500 leading-relaxed">{m.description}</p>
              </div>
              <div className={`w-5 h-5 flex items-center justify-center rounded-full border shrink-0 ${
                isActive ? 'bg-orange-500 border-orange-500' : 'border-stone-600'
              }`}>
                {isActive && <i className="ri-check-line text-white text-xs" />}
              </div>
            </button>
          );
        })}

        {/* Coming Soon */}
        <div className="flex items-center gap-4 px-4 py-3.5 rounded-xl border border-dashed border-stone-700/50 bg-stone-800/20 opacity-60 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-orange-500/5 to-transparent pointer-events-none" />
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-stone-800/80 shrink-0">
            <i className="ri-rocket-line text-base text-orange-400/50" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-0.5">
              <span className="text-sm font-semibold text-stone-400">Direct Publish</span>
              <span className="text-xs px-2 py-0.5 rounded-full bg-orange-500/20 text-orange-400/80 font-medium border border-orange-500/20">
                Coming Soon
              </span>
            </div>
            <p className="text-xs text-stone-600">Publish directly to Meta Ads Manager, TikTok, and Google Ads.</p>
          </div>
          <div className="w-5 h-5 flex items-center justify-center rounded-full border border-stone-700 shrink-0">
            <i className="ri-lock-2-line text-stone-600 text-xs" />
          </div>
        </div>
      </div>
    </div>
  );
}
